/* eslint-disable import/order */
import type { EntryPointComponent } from 'react-relay';
import { createChromelessEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { DashboardBackgroundScripts } from '@jira/platform__layouts-background-scripts-layout/src/ui/dashboard/index.tsx';
import { DASHBOARD } from '@jira/platform__observability-capabilities/src/constants.tsx';
import { NORMAL_EARLY_ASSET_STRATEGY } from '@jira/platform__common-constants/src/ssr-early-assets.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { createLayout } from '@jira/platform__layouts-route-layout/src/GlobalComponent.tsx';
import { jiraSpaResources } from '@jira/router-resources__spa-page-container/src/jiraSpaResources.tsx';
import { dashboardViewEmbedRoute } from '@jira/router-routes__dashboard-routes/src/dashboardViewEmbedRoute.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import type { Route } from '@atlassian/react-resource-router';
import {
	DashboardViewEmbedPage,
	dashboardResources,
	LazyDashboardViewEmbed,
	LazyForPaintBackgroundScripts,
	LazyForPaintConnectJsApi,
} from './ui/index.tsx';

const dashboardViewEmbedPageEntryPoint = createChromelessEntryPoint({
	main: {
		root: JSResourceForUserVisible<EntryPointComponent<{}, {}, {}, {}>>(
			/* webpackChunkName: "async-dashboard-view-embed", jiraSpaEntry: "async-dashboard-view-embed" */ './DashboardViewEmbedRoot.tsx',
			{ entryFsSsrLiftImportToModule: false },
		),
		getPreloadProps: () => ({}),
	},
});

export const dashboardViewEmbedRouteEntry: Route = createEntry(dashboardViewEmbedRoute, () => ({
	group: 'dashboard',

	// eslint-disable-next-line no-restricted-syntax
	component: fg('nike_entrypoint_migration_batch_1') ? undefined : DashboardViewEmbedPage,

	entryPoint: () =>
		fg('nike_entrypoint_migration_batch_1') ? dashboardViewEmbedPageEntryPoint : undefined,

	layout: createLayout({
		globalComponents: [DashboardBackgroundScripts],
		isChromeless: true,
	}),

	resources: [...jiraSpaResources(), ...dashboardResources()],
	forPaint: [LazyDashboardViewEmbed, LazyForPaintBackgroundScripts, LazyForPaintConnectJsApi],

	meta: {
		capability: DASHBOARD,
	},

	earlyAssets: NORMAL_EARLY_ASSET_STRATEGY,
	wrmMode: 'early',

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
